<div class="common-details-nav d-flex">
  <div class="row nav">
    <debtor-panel-breadcrumb></debtor-panel-breadcrumb>
    <div><a href="#" class="return-form-link link" (click)="navigateToClick($event)">{{ this.backToText()| translate }}</a></div>
  </div>
  <ng-content></ng-content>
</div>